var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopilotLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2497 3.33325C21.2497 2.6429 20.69 2.08325 19.9997 2.08325C10.1046 2.08325 2.08301 10.1048 2.08301 19.9999C2.08301 29.895 10.1046 37.9166 19.9997 37.9166C29.8948 37.9166 37.9163 29.895 37.9163 19.9999C37.9163 19.3096 37.3567 18.7499 36.6663 18.7499C35.976 18.7499 35.4163 19.3096 35.4163 19.9999C35.4163 28.5143 28.5141 35.4166 19.9997 35.4166C11.4853 35.4166 4.58301 28.5143 4.58301 19.9999C4.58301 11.4855 11.4853 4.58325 19.9997 4.58325C20.69 4.58325 21.2497 4.02361 21.2497 3.33325Z",
    fill: "#1777CF",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "copilot-loading-animation",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1663 2.08325C29.8567 2.08325 30.4163 2.6429 30.4163 3.33325C30.4163 5.84208 30.9563 7.31417 31.8328 8.18494C32.7109 9.05735 34.1852 9.58325 36.6663 9.58325C37.3567 9.58325 37.9163 10.1429 37.9163 10.8333C37.9163 11.5236 37.3567 12.0833 36.6663 12.0833C34.1935 12.0833 32.7169 12.6213 31.8357 13.5026C30.9544 14.3838 30.4163 15.8604 30.4163 18.3333C30.4163 19.0236 29.8567 19.5833 29.1663 19.5833C28.476 19.5833 27.9163 19.0236 27.9163 18.3333C27.9163 15.8625 27.3752 14.3853 26.4918 13.5033C25.6079 12.6209 24.1301 12.0833 21.6663 12.0833C20.976 12.0833 20.4163 11.5236 20.4163 10.8333C20.4163 10.1429 20.976 9.58325 21.6663 9.58325C24.1385 9.58325 25.6139 9.05781 26.4947 8.18422C27.3734 7.31269 27.9163 5.84001 27.9163 3.33325C27.9163 2.6429 28.476 2.08325 29.1663 2.08325ZM29.1641 8.8111C28.9069 9.22849 28.6053 9.61196 28.2552 9.9592C27.9126 10.299 27.5358 10.5919 27.1274 10.8421C27.5371 11.0954 27.9148 11.3914 28.2581 11.7341C28.6069 12.0823 28.9075 12.4661 29.1641 12.8832C29.42 12.4664 29.7199 12.0828 30.0679 11.7348C30.4109 11.3918 30.7885 11.0955 31.1983 10.8421C30.7898 10.5917 30.4132 10.2986 30.0708 9.95848C29.7214 9.6114 29.4206 9.22816 29.1641 8.8111Z",
    fill: "#1777CF",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopilotLoading);
export default __webpack_public_path__ + "static/media/copilot-loading.36cb39224452353a2d7a8290d48ac784.svg";
export { ForwardRef as ReactComponent };